import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-user-workingdays',
  templateUrl: './user-workingdays.component.html',
  styleUrls: ['./user-workingdays.component.css']
})
export class UserWorkingdaysComponent implements OnInit {

  constructor(private brandService: ServiceService, private router: Router, private route: ActivatedRoute) { }

  public model = [];
  minDate = new Date()
  maxDate = new Date()
  calenderShown = false
  output: any = []; //---store get() result--------
  DName = "*"
  MName = "*"
  Date = ""

  data = {
    user_id: "",
    month_year: "",
    working_days: []
  }

  isShown: boolean = false;
  alert = ""
  message = ""
  department: any = [];

  getdata: any = [];
  setData: any;
  array: any;
  parts=Array()

  Month = [{ name: "January", id: "01", last: 31 },
  { name: "February", id: "02", last: 28 },
  { name: "March", id: "03", last: 31 },
  { name: "April", id: "04", last: 30 },
  { name: "May", id: "05", last: 31 },
  { name: "June", id: "06", last: 30 },
  { name: "July", id: "07", last: 31 },
  { name: "August", id: "08", last: 31 },
  { name: "September", id: "09", last: 30 },
  { name: "October", id: "10", last: 31 },
  { name: "November", id: "11", last: 30 },
  { name: "December", id: "12", last: 31 },
  ]




  shown() {
    this.isShown = false
  }
  notification() {
    this.isShown = !this.isShown;
  }

  //---------function for edit brand detail-----
  btnClick() {

    let check = false
    let Id=this.data.user_id

    console.log("Data=", this.data)

    this.data.working_days = this.model
  //  this.router.navigate(['admin/user-working-days-list'],{queryParams:{setData:JSON.stringify({Id})}});
   // return

    this.brandService.createUserWorkingDays(this.data).subscribe((res) => { 
      this.alert=res.message;
      console.log("res=",res);
      if(res.success==true){
        this.router.navigate(['admin/user-working-days-list'],{queryParams:{setData:JSON.stringify({Id})}});
      }
     
    })
  }

  MonthSelected() {
    this.model = [];
   
    console.log("year=", this.Date)
    this.data.month_year=this.Date
    this.parts = this.Date.split('-');
    console.log("parts=", this.parts)
    const lastDay = new Date(this.parts[0], this.parts[1], 0);
    var numberOfDays = lastDay.getDate();

    //---------set max and min for calender-------
    var start=this.parts[1]+"/"+"1"+"/"+this.parts[0]
    var end=this.parts[1]+"/"+numberOfDays+"/"+this.parts[0]
    console.log("start=", start)
    console.log("end=", end)
    this.minDate= new Date(start)
    this.maxDate= new Date(end)
    this.calenderShown=true
  }

  getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear(); // Get the current year
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1 and ensure two digits
    return `${year}-${month}`;
  }
  ngOnInit(): void {


    this.Date=this.getFormattedDate();
    this. MonthSelected();
    this.route.queryParams.subscribe((params) => {
      this.getdata = params;
      this.setData = this.getdata.setData;
      const obj = JSON.parse(this.setData);
      this.array = [obj];

       this.data.user_id=this.array[0].Id;
    })
  }

}
